module.exports = {"TXTCLI_How_it_worksX":{"id":"TXTCLI_How_it_worksX","defaultMessage":"Jak to funguje:","track":"How it works."}}